module.exports = __webpack_public_path__ + "img/active-22.447301df.svg";